import ServiceFetch from '../../utilities/ServiceFetch.js';
/**
 * This class is used for validating zip code .
 */
export default class DexfZipValidationService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF Api key.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Fetches the validity of a given zip code.
     *
     * @param zipCode ...
     */
    async getZipValidation(zipCode) {
        const options = {
            credentials: 'same-origin',
            headers: {
                'dexf-api-key': this.dexfApiKey
            }
        };
        const url = `${this.endpoint.replace('{zipCode}', encodeURIComponent(zipCode.replace(/ /g, '')))}`;
        const response = await ServiceFetch.json(url, options);
        return response;
    }
}
//# sourceMappingURL=DexfZipValidationService.js.map